import { useContext } from 'react';
import { LocationConfigContext } from '../context/LocationConfigContext';

export function useLocationConfig() {
  const context = useContext(LocationConfigContext);
  if (context === undefined) {
    throw new Error('useLocationConfig must be used within a LocationConfigProvider');
  }
  return context;
}
